import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "floating-div mr-4 mt-4" }
const _hoisted_2 = { class: "toolbar d-flex flex-wrap justify-end ml-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_l_tile_layer = _resolveComponent("l-tile-layer")!
  const _component_map_marker = _resolveComponent("map-marker")!
  const _component_l_polygon = _resolveComponent("l-polygon")!
  const _component_map_search_bar = _resolveComponent("map-search-bar")!
  const _component_l_map = _resolveComponent("l-map")!

  return (_openBlock(), _createBlock(_component_l_map, _mergeProps(_ctx.$attrs, {
    ref: "lMapRef",
    zoom: _ctx.zoom,
    center: _ctx.center,
    options: {
      zoomSnap: 0.5,
      doubleClickZoom: false,
      markerZoomAnimation: false,
      zoomAnimation: false,
    },
    "data-testid": "map",
    style: {"height":"100%","width":"100%","min-height":"150px","min-width":"150px"},
    onZoomend: _ctx.emitZoomLevelChanged,
    onReady: _ctx.onMapReady
  }), {
    default: _withCtx(() => [
      _createVNode(_component_l_tile_layer, {
        url: _ctx.url,
        attribution: _ctx.attribution
      }, null, 8, ["url", "attribution"]),
      _renderSlot(_ctx.$slots, "map", {}, undefined, true),
      (
        _ctx.locationSearchResult && _ctx.locationSearchResult.geometry.type === 'Point'
      )
        ? (_openBlock(), _createBlock(_component_map_marker, {
            key: _ctx.locationSearchResult.locationId,
            interactive: false,
            "lat-lng": _ctx.locationSearchResult.geometry.coordinates,
            icon: "red",
            animation: "bounce"
          }, null, 8, ["lat-lng"]))
        : (
        _ctx.locationSearchResult && _ctx.locationSearchResult.geometry.type === 'Polygon'
      )
          ? (_openBlock(), _createBlock(_component_l_polygon, {
              key: 1,
              color: "#e55244",
              "fill-color": "#e55244",
              "lat-lngs": _ctx.locationSearchResult.geometry.coordinates
            }, null, 8, ["lat-lngs"]))
          : (
        _ctx.locationSearchResult &&
          _ctx.locationSearchResult.geometry.type === 'MultiPolygon'
      )
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.locationSearchResult.geometry.coordinates, (polygon, i) => {
                return (_openBlock(), _createBlock(_component_l_polygon, {
                  key: i,
                  color: "#e55244",
                  "fill-color": "#e55244",
                  "lat-lngs": polygon
                }, null, 8, ["lat-lngs"]))
              }), 128))
            : _createCommentVNode("", true),
      _createVNode(_component_l_polygon, {
        "lat-lngs": _ctx.austriaPolygonData,
        color: "#6F7189",
        weight: 2,
        fill: false,
        interactive: false
      }, null, 8, ["lat-lngs"]),
      _createVNode(_component_l_polygon, {
        "lat-lngs": _ctx.federalStatesPolygonData,
        color: "#6F7189",
        weight: 1,
        fill: false,
        interactive: false
      }, null, 8, ["lat-lngs"]),
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stopClick && _ctx.stopClick(...args))),
        onMouseenter: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.disableDragging && _ctx.disableDragging(...args))),
        onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.enableDragging && _ctx.enableDragging(...args)))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "tools", {}, undefined, true),
            _createElementVNode("div", null, [
              _createVNode(_component_map_search_bar, {
                class: "width-300",
                onZoomToLocation: _ctx.zoomToLocation,
                onResetSearch: _ctx.resetSearchState
              }, null, 8, ["onZoomToLocation", "onResetSearch"])
            ])
          ])
        ])
      ], 32)
    ]),
    _: 3
  }, 16, ["zoom", "center", "onZoomend", "onReady"]))
}